// extracted by mini-css-extract-plugin
export default {"base":"vp_jPiFC","directionLeft":"vp_UvmOv","directionRight":"vp_AqOmg","colorWarning":"vp_hFtOB"};